import React from 'react';
import {RegistrationWizard} from 'widgets/registration';

export function ProfileStatusesPage(): React.ReactElement {
	return <RegistrationWizard entry="statuses" />;
}
